import { useEffect, useState } from "react";
// import axiosInstances from "../components/axiosInstance";
import axios from "axios";
import Wrapper from "../components/Wrapper";
import NotificationBar from "../components/NotificationBar";
import SmallCard from "../components/SmallCard";
import CardContainer from "../components/CardContainer";
// import DataTable from "../components/DataTable";
import { FcSms,FcMoneyTransfer, FcLeftDown2, FcLeftDown ,FcRightUp2, FcRightUp} from "react-icons/fc";
import { TfiMoney,TfiComments  } from "react-icons/tfi";
import { TbPigMoney,TbReportMoney } from "react-icons/tb";
import { SlEvent,SlBubbles } from "react-icons/sl";


const Dashboard = ()=>{
 
   
    const [totalDeposits, setTotalDeposits] = useState(0);
    const [depositsToday, setDepositsToday] = useState(0);
    const [totalPayouts, setTotalPayouts] = useState(0);
    const [payoutsToday, setPayoutsToday] = useState(0);
    const [smsIn, setSmsIn] = useState(0);
    const [smsOut, setSmsOut] = useState(0);
    const [smsInToday, setSmsInToday] = useState(0);
    const [smsOutToday, setSmsOutToday] = useState(0);
    const [c2bUtility,setC2bUtility] = useState("");
    const [b2cUtility,setB2cUtility] = useState("");
    const [c2bWorking, setC2bWorking] = useState("");
    const [b2cWorking, setB2cWorking] = useState("");

    useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`dashboardTiles`);
            setTotalDeposits(data.total_deposits);
            setDepositsToday(data.deposits_today);
            setTotalPayouts(data.total_payouts);
            setPayoutsToday(data.payouts_today);
            setSmsIn(data.sms_in);
            setSmsOut(data.sms_out);
            setSmsInToday(data.sms_in_today);
            setSmsOutToday(data.sms_out_today);
            setC2bUtility(data.c2b_utility);
            setC2bWorking(data.c2b_working);
            setB2cUtility(data.b2c_utility);
            setB2cWorking(data.b2c_working);

            //console.log(data);

        }
        )();
    },[]);
    return (
        <Wrapper pageTitle={'Dasboard'}>
            <NotificationBar />
                    <CardContainer>
                    <SmallCard title={'Total Deposits'} number={totalDeposits ? totalDeposits : "n/a"} icon={FcMoneyTransfer}></SmallCard>
                        <SmallCard title={'Total Payouts'} number={totalPayouts ? totalPayouts : "n/a"}   icon={TfiMoney}></SmallCard>
                        <SmallCard title={'Deposits Today'} number={depositsToday ? depositsToday: " n/a"}  icon={TbPigMoney}></SmallCard>
                          <SmallCard title={'Payouts Today'} number={payoutsToday ? payoutsToday: " n/a"}  icon={TbReportMoney}></SmallCard>  
                        <SmallCard  title={'SMS IN'} number={smsIn ? smsIn: " n/a"}  icon={FcSms}></SmallCard>   
                        <SmallCard  title={'SMS OUT'} number={smsOut ? smsOut: " n/a"}  icon={TfiComments }></SmallCard>   
                        <SmallCard  title={'SMS IN Today'} number={smsInToday ? smsInToday: " n/a"}  icon={SlEvent}></SmallCard>   
                        <SmallCard  title={'SMS OUT Today'} number={smsOutToday ? smsOutToday: " n/a"}  icon={SlBubbles }></SmallCard> 

                        <SmallCard  title={'C2B Utility'} number={c2bUtility ? c2bUtility: " n/a"}  icon={FcLeftDown2 }></SmallCard>  
                        <SmallCard  title={'C2B Working'} number={c2bWorking ? c2bWorking: " n/a"}  icon={FcLeftDown }></SmallCard>  
                        <SmallCard  title={'B2C Utility'} number={b2cUtility ? b2cUtility: " n/a"}  icon={FcRightUp2 }></SmallCard>  
                        <SmallCard  title={'B2C Working'} number={b2cWorking ? b2cWorking: " n/a"}  icon={FcRightUp }></SmallCard>  
                    </CardContainer>

                    {/* <DataTable /> */}
                    


        </Wrapper>
    );
};

export default Dashboard;